/**
 * Definições das etapas de configuração inicial do tenant.
 * Usadas pelo SetupProgress para exibir o progresso ao administrador.
 */

export interface SetupStepDefinition {
  id: string;
  label: string;
  description: string;
  checkEndpoint: string; // endpoint to check if step is complete
  navigateTo: string; // route to navigate when clicking
}

export const setupStepDefinitions: SetupStepDefinition[] = [
  {
    id: 'setup-tenant',
    label: 'Dados do Tenant',
    description: 'Configure os dados básicos do seu tenant',
    checkEndpoint: '/tenants/current',
    navigateTo: '/admin/setup',
  },
  {
    id: 'setup-users',
    label: 'Usuários',
    description: 'Crie pelo menos 1 usuário adicional',
    checkEndpoint: '/users',
    navigateTo: '/admin/users',
  },
  {
    id: 'setup-provider',
    label: 'Provider',
    description: 'Configure pelo menos 1 provider de pagamento',
    checkEndpoint: '/provider-instances',
    navigateTo: '/admin/provider-instances',
  },
  {
    id: 'setup-modules',
    label: 'Módulos',
    description: 'Ative os módulos desejados para o tenant',
    checkEndpoint: '/modules',
    navigateTo: '/admin/modules',
  },
  {
    id: 'setup-fees',
    label: 'Taxas',
    description: 'Configure as regras de taxas do tenant',
    checkEndpoint: '/fee-rules',
    navigateTo: '/admin/fee-rules',
  },
  {
    id: 'setup-theme',
    label: 'Tema',
    description: 'Personalize o visual da plataforma',
    checkEndpoint: '/themes/my-theme',
    navigateTo: '/admin/setup',
  },
];
